


















































































































import { formatCurrency } from "@/lib/utility/currency-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { InvoiceLine } from "@/models/invoice-line.entity";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import Tooltip from "../utility/tooltip.vue";

@Component({
  components: {
    Tooltip
  },
  filters: {}
})
export default class LineItemsForm extends mixins(PermissionMixin, RulesMixin) {
  readonly formatCurrency = formatCurrency;

  @Prop()
  value!: Pick<
    IRepairEstimate,
    "lineItems" | "currency" | "totalGross" | "totalNet" | "taxRates" | "calcItemsPerTaxRate"
  >;

  addInvoiceLine() {
    const li = new InvoiceLine();
    this.value.lineItems.push(li);
  }

  removeInvoiceLine(index: number) {
    this.value.lineItems.splice(index, 1);
  }
}
